<template>
	<!-- width="600px" 或者  width="60%"   -->
	<el-dialog :close-on-click-modal="false" title="添加拜访" :show-close="true" :visible="true"
		:before-close="handleBeforeClose" width="625px">
		<div class="dialog__container">
			<el-form inline ref="form" class="search-form" label-position="right" :model="form" :rules="rules"
				label-width="70px">
				<el-form-item label="销售项目：" prop="projectId">
					<el-select size="mini" v-model="form.projectId" filterable placeholder="请选择销售项目" clearable
						reserve-keyword :remote="true" :remote-method="searchProjectList"
						@visible-change="searchProjectList('')">
						<el-option v-for="item in projectList" :key="item.id" :label="item.projectName"
							:value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="联系人员：" prop="operator" class="mr0">
					<el-select size="mini" v-model="form.operator" filterable placeholder="请选择联系人员" clearable
						reserve-keyword :remote="true" :remote-method="getUserSimpleListFun"
						@visible-change="getUserSimpleListFun('')" value-key="userId">
						<el-option v-for="item in peopleList" :key="item.userId" :label="item.nickname"
							:value="item"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="沟通内容：" class="input-with-col2 mr0">
					<el-input size="mini" type="textarea" :rows="4" v-model.trim="form.content" placeholder="请输入沟通内容"
						clearable></el-input>
				</el-form-item>
				<el-form-item :label="`图片：`" class="input-with-col2 mr0">
					<el-upload action="/KYWB/foreign/storage/uploadFile" :headers="headersObj" list-type="picture-card"
						:file-list="liveImageFileList" :on-preview="handlePictureCardPreview" :on-remove="handleRemove"
						:on-success="handleSuccess">
						<i class="el-icon-plus"></i>
					</el-upload>
				</el-form-item>
				<el-form-item label="下次回访：">
					<el-date-picker v-model="form.nextVisitTime" type="date" size="mini" value-format="yyyy-MM-dd"
						placeholder="请选择下次回访日期" clearable prefix-icon=" "></el-date-picker>
				</el-form-item>
			</el-form>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button class="plr28" size="mini" type="info" plain @click="handleCancel">取消</el-button>
			<el-button class="plr28" type="primary" size="mini" :loading="loadBtn" @click="handleConfirm">确定</el-button>
		</span>
		<el-dialog :visible.sync="dialogVisible" :modal="false">
			<img width="100%" :src="dialogImageUrl" alt="" />
		</el-dialog>
	</el-dialog>

</template>

<script>
import { saveData, uploadFile, getUserSimpleList } from "@/api/salesManagement/bfjl"
import cookies from "@/libs/util.cookies";
import { getProjectSimpleList } from "@/api/salesManagement/ProjectManagement";
export default {
	data() {
		return {
			fileList: [],
			form: {
				nextVisitTime: null,
				content: '',
				projectId: null,
				operator: null

			},
			headersObj: {
				Authorization: "Bearer " + cookies.get("token"),
				appCode: "YHGHT",
			},
			rules: {
				projectId: [
					{
						required: true,
						message: "请选择销售项目",
						trigger: "change",
					},
				],
				operator: [
					{
						required: true,
						message: "请选择联系人员",
						trigger: "change",
					},
				],
			},
			loadBtn: false,
			dialogVisible: false,
			dialogImageUrl: '',
			liveImageFileList: [],
			projectList: [],
			peopleList: []
		};
	},
	props: {
		detail: {
			required: true,
			type: Object,
		},
	},
	created() {
		this.getUserSimpleListFun()
		this.searchProjectList()
		const params = {};
		params.projectId = this.detail.projectId;
		params.nextVisitTime = this.detail.nextVisitTime;
		params.content = this.detail.content;
		let imgs  = [];
		if (this.detail.imageUrlList && this.detail.imageUrlList.length) {
			imgs=this.detail.imageUrlList.split(',').map(item=> ({
				uid: item,
				url: item
			}))
		}
		this.liveImageFileList = imgs
		this.form = { ...params, operator: {
			nickname: this.detail.operatorName,
			userId: this.detail.operatorId
		} };
		console.log(this.form)

	},
	methods: {
		async getUserSimpleListFun(v = "") {
			this.canSearch = false;
			const res = await getUserSimpleList({ keyword: v, size: 1000 });
			if (res.code === 200) {
				this.peopleList = res.data;
			}
			this.canSearch = true;
		},
		async searchProjectList(keyword) {
			const res = await getProjectSimpleList({
				keyword: keyword,
				size: 100,
			});
			if (res.code === 200) {
				this.projectList = res.data;
			}
		},
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url;
			this.dialogVisible = true;
		},
		uploadFileRequest(params, index) {
			const file = params.file;
			// 根据后台需求数据格式
			const form = new FormData();
			// 文件对象
			form.append("file", file);
			uploadFile(form)
				.then((response) => {
					if (response.code === 200) {
						this.$message.success("上传成功");
						let data = response.data;
						let resource = this.form.documentItemList[index];
						resource.resourcesPath = [
							{
								name: data.name,
								url: data.url,
								resourcesPath: data.url,
								resourcesType: data.type,
							},
						];
						this.form.documentItemList.splice(index, 1, resource);
					} else {
						this.$message.error("上传失败，请联系管理员");
					}
				})
				.catch((error) => {
					console.log(error);
					this.$message.error("上传失败，请联系管理员");
				});
		},
		handleRemove(file, fileList) {
			console.log(fileList);
			this.liveImageFileList = fileList;
		},

		handleSuccess(res) {
			console.log(res)
			if (res && res.data) {
				this.liveImageFileList.push({
					name: res.data.url,
					url: res.data.url,
				});
			}
		},

		addDocument() {
			this.form.documentItemList.push({
				resourcesPath: [],
				description: "",
			});
			console.log(this.form.documentItemList);
		},
		delectDocument(index) {
			this.form.documentItemList.splice(index, 1);
		},

		handlePreview(file) {
			window.open(file.resourcesPath, "_blank");
		},

		handleBeforeClose(done) {
			this.$emit("cancel");
			done();
		},
		handleCancel() {
			this.$emit("cancel");
		},
		async handleConfirm() {
			if (this.loadBtn) return;
			this.$refs["form"].validate(async (valid) => {
				if (valid) {
					this.loadBtn = true;
					const params = {
						projectId: this.form.projectId,
						content: this.form.content,
						nextVisitTime: this.form.nextVisitTime,
						id: this.detail.id
					};
					if (this.liveImageFileList) {
						params.imageUrlList = this.liveImageFileList.map(item=>item.url).join(',')
					}
					if (this.form.operator) {
						params.operatorId = this.form.operator.userId
						params.operatorName = this.form.operator.nickname
					}

					const res = await saveData(params);
					if (res.code === 200) {
						this.$message.success("编辑成功");
						this.$emit("confirm");
					}
					this.loadBtn = false;
				}
			});
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/salesManagement/bfjl/components/EditCause.vue